import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { viewImage } from '../../CommonUtils/viewImage';
import { successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { FaEdit, FaEye, FaTimesCircle } from 'react-icons/fa';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
//priyanka ,Anitha akka
export default function GrievancyReport() {
    const [filterType, setFilterType] = useState("all");
    const [Grievancedata, setGrievancedata] = useState([]);
    const GetUnivlist = () => {
        CommonAxiosGet(config.url.FAC_URL + "GrievanceReport").then((res) => {
            if (res?.data?.scode === "01") {
                setGrievancedata(res?.data?.data || []);
            } else {
                setGrievancedata([]);
            }
        });
    };
    function CloseConcern(greivId, collCode, isResolved = false, existingRemarks = "") {
        const dummyFormik = {

            values: {},
            setFieldValue: (field, value) => {
                dummyFormik.values[field] = value;
            }
        };
        Swal.fire({
            title: isResolved ? "Edit Closed Ticket" : "Close Ticket",
            html: `
            <div style="text-align:left">
                <p><strong>Concern ID:</strong> ${greivId}</p>
                <p><strong>College Code:</strong> ${collCode}</p>

                <label style="font-weight:bold;">
                    Remarks <span style="color:red">*</span>
                </label>
                <textarea
                    id="swal-remarks"
                    class="swal2-textarea"
                    placeholder="Enter remarks"
                    style="margin:10px 0; width:100%;"
                >${existingRemarks}</textarea>

                <label style="font-weight:bold;">
                    Upload Supporting Document (PDF)
                </label>
                <input
                    id="swal-file"
                    type="file"
                    class="swal2-file"
                    accept=".pdf"
                />
            </div>
        `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: isResolved ? "Update Concern" : "Submit & Close",
            cancelButtonText: "Cancel",
            confirmButtonColor: isResolved ? "#0d6efd" : "#d33",
            preConfirm: async () => {
                const remarks = document.getElementById("swal-remarks")?.value?.trim();
                const fileInput = document.getElementById("swal-file");
                if (!remarks) {
                    Swal.showValidationMessage("Remarks are required");
                    return false;
                }
                let filePath = "";
                if (fileInput?.files[0]) {
                    const fakeEvent = {
                        preventDefault: () => { },
                        target: {
                            files: [fileInput.files[0]]
                        }
                    };
                    await ImagePdfBucket(
                        fakeEvent,
                        dummyFormik,
                        "/Uploads/grievupload/",
                        "grievupload",
                        "grievupload",
                        "pdf"
                    );
                    filePath = dummyFormik.values.grievupload || "";
                }
                return { remarks, filePath };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const { remarks, filePath } = result.value;

                const formData = new FormData();
                formData.append("grievId", greivId);
                formData.append("statusRemarks", remarks);
                formData.append("supportDoc", filePath);
                try {
                    const response = await CommonAxiosPost(
                        config.url.FAC_URL + "updateStatus",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    );

                    if (response?.data?.scode === "01") {
                        successAlert2(response.data.sdesc);
                        GetUnivlist();
                    }

                } catch (error) {
                    Swal.fire(
                        "Error",
                        error?.response?.data?.sdesc || "Something went wrong"
                    );
                }
            }
        });
    }
    useEffect(() => {
        GetUnivlist();
    }, []);
    const StatusColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            accessorKey: "griev_id",
            header: "Concern ID",
        },
        {
            accessorKey: "inst_name",
            header: "Institution Name",
        },
        {
            accessorKey: "coll_code",
            header: "College Code",
        },
        {
            accessorKey: "grievance",
            header: "Concern Description",
        },
        {
            accessorKey: "mobileno",
            header: "Mobile Number",
        },
        {
            accessorKey: "noc_type",
            header: "NOC Type",
        },
        {
            accessorKey: "status",
            header: "Status",
            cell: ({ row }) => (
                <span style={{ color: row.original.status ? "green" : "red" }}>
                    {row.original.status ? "Resolved" : "Pending"}
                </span>
            ),
        },
        {
            accessorKey: "grievupload",
            header: "Attachment",
            cell: ({ row }) => {
                const filePath = row.original.grievupload;
                if (!filePath) {
                    return "-";
                }
                return (
                    <button className='btb btn-primary'
                        type="button"
                        onClick={() => viewImage(filePath)}
                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "blue",
                        }}
                        title="View Attachment"
                    >
                        <FaEye size={12} />
                    </button>
                );
            },
        },

        {
            accessorKey: "insert_time",
            header: "Submitted On",
            cell: ({ row }) => {
                const date = new Date(row.original.insert_time);
                if (isNaN(date)) return "Invalid date";
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = String(date.getFullYear()).slice(-2);
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const ampm = hours >= 12 ? "pm" : "am";
                hours = hours % 12;
                if (hours === 0) hours = 12; // 12am/pm
                const time = `${hours}.${minutes}${ampm}`;

                return `${day}/${month}/${year} ${time}`;
            },
        },
        {
            accessorKey: "status_remarks",
            header: "Remarks",
            cell: ({ row }) => {
                const remarks = row.original.status_remarks;
                const isResolved = row.original.status;
                const supportDoc = row.original.support_doc;
                return (
                    <div>
                        <div>{remarks || "-"}</div>
                        {isResolved && supportDoc && (
                            <button
                                type="button"
                                onClick={() => viewImage(supportDoc)}
                                style={{
                                    cursor: "pointer",
                                    color: "#0d6efd",
                                    marginTop: "4px",
                                    textAlign: "center",
                                    background: "none",
                                    border: "none"
                                }}
                                title="View Supporting Document"
                            >
                                <FaEye />
                            </button>
                        )}
                    </div>
                );
            },
        },

        {
            id: "action",
            header: "Edit / Close Ticket",
            cell: ({ row }) => {
                const grievId = row.original.griev_id;
                const isResolved = row.original.status;
                console.log("row.original.status", isResolved)

                return (
                    <button
                        onClick={() =>
                            CloseConcern(
                                grievId,
                                row.original.coll_code,
                                row.original.status,
                                row.original.status_remarks || ""
                            )
                        }
                        // disabled={isResolved}
                        style={{
                            // "#ccc"
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto",
                            backgroundColor: isResolved ? "#0d6efd" : "#dc3545",
                            color: "#fff",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            textAlign: "center",
                        }}
                    >
                        {/* {isResolved ? "Edit Closed Ticket" : "Close Ticket"} */}
                        <>
                            {isResolved ? (
                                <>
                                    <FaEdit />
                                    {/* Edit Closed Ticket */}
                                </>
                            ) : (
                                <>
                                    <FaTimesCircle />
                                    {/* Close Ticket */}
                                </>
                            )}
                        </>
                    </button>
                );
            },
        }
    ];
    const filteredData = Grievancedata.filter(item => {
        if (filterType === "pending") return item.status === false;
        if (filterType === "resolved") return item.status === true;
        return true; // all
    });
    const allCount = Grievancedata.length;
    const pendingCount = Grievancedata.filter(
        item => item.status === false
    ).length;
    const resolvedCount = Grievancedata.filter(
        item => item.status === true
    ).length;
    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <h5 className="mb-3 innerheader-new">
                        <span>  Concern  Status Report</span>
                    </h5>
                    {/* <h6
                        style={{
                            fontWeight: "bold",
                            marginBottom: "12px",
                            color: "#063e6b"
                        }}
                    >
                        Choose the Ticket Type
                    </h6> */}
                    <div
                        style={{
                            display: "flex",
                            gap: "15px",
                            marginBottom: "20px",
                            borderBottom: "2px solid #ddd",
                            paddingBottom: "10px"
                        }}
                    >

                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    setFilterType("all");
                                }
                            }}
                            onClick={() => setFilterType("all")}
                            style={{

                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "6px",
                                backgroundColor:
                                    filterType === "all" ? "#4f46e5" : "#f1f1f1",
                                color:
                                    filterType === "all" ? "#fff" : "#000",
                                fontWeight: "bold"
                            }}
                        >
                            📋   All ({Grievancedata.length})
                        </div>

                        {/* PENDING */}
                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    setFilterType("pending");
                                }
                            }}
                            onClick={() => setFilterType("pending")}
                            style={{
                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "6px",
                                backgroundColor:
                                    filterType === "pending" ? "#dc3545" : "#f1f1f1",
                                color:
                                    filterType === "pending" ? "#fff" : "#000",
                                fontWeight: "bold"
                            }}
                        >
                            ⏳   Pending Tickets (
                            {
                                Grievancedata.filter(
                                    item => item.status === false
                                ).length
                            }
                            )
                        </div>

                        {/* RESOLVED */}
                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    setFilterType("resolved");
                                }
                            }}
                            onClick={() => setFilterType("resolved")}
                            style={{
                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "6px",
                                backgroundColor:
                                    filterType === "resolved" ? "#0d6efd" : "#f1f1f1",
                                color:
                                    filterType === "resolved" ? "#fff" : "#000",
                                fontWeight: "bold"
                            }}
                        >
                            ✅    Closed & Edit Ticket (
                            {
                                Grievancedata.filter(
                                    item => item.status === true
                                ).length
                            }
                            )
                        </div>
                    </div>
                    {Grievancedata?.length > 0 && (<>
                        <div className="table-responsive">
                            <CommonReactTable
                                data={filteredData}
                                // data={Grievancedata}
                                columns={StatusColumns}
                                filename="CONCERN STATUS REPORT"
                                headerName="CONCERN STATUS REPORT"
                                showFooter={false}
                                showPagination={false}
                                showExcel={true}
                                showPrint={true}
                                excelFileName="CONCERN STATUS REPORT"
                            />


                        </div>
                    </>
                    )}
                </div>
            </div>
        </>
    )
}
